import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import Swiper from "swiper";
import type { SwiperOptions } from "swiper/types";
import { SwiperComponent, SwiperModule } from "swiper/angular";

@Component({
  selector: "app-confirmation-promotions",
  templateUrl: "./confirmation-promotions.component.html",
  styleUrls: ["./confirmation-promotions.component.scss"],
  standalone: true,
  imports: [IonicModule, CommonModule, SwiperModule],
})
export class ConfirmationPromotionsComponent implements OnDestroy {
  @Input() promotions: any[] = [];
  @Input() processingStates: boolean[] = [];
  @Input() expiryMinutes: number | null = null;
  @Input() seconds: number | null = null;
  @Output() offerPayment = new EventEmitter<{ item: any; index: number }>();

  @ViewChild("slider") slider: SwiperComponent;

  // state moved from host
  storeSliderOptions2: SwiperOptions = {
    speed: 500,
    slidesPerView: 1.15,
    centeredSlides: true,
    pagination: {
      el: ".swiper-pagination-2",
      clickable: true,
    },
    // Disabled: slides contain CTA buttons that navigate away. Swiper's rAF callback races
    // with ionViewWillLeave(), leaving params undefined. Explicit false prevents regressions
    // if Swiper defaults or shared configs change. LOTTOSOCIAL-PWA-1NCK
    slideToClickedSlide: false,
    autoplay: {
      delay: 5000,
    },
  };

  slides: Swiper;
  interval: any;
  autoSlide = true;
  speed = 500;

  constructor() { }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  setSwiperInstance(swiper: Swiper) {
    this.slides = swiper;

    clearInterval(this.interval);

    setTimeout(() => {
      this.interval = setInterval(() => {
        if (!this.slides || !this.slides.autoplay) return;
        if (!this.autoSlide) {
          this.slides?.autoplay?.stop();
        } else {
          this.slides.slideNext(this.speed);
          this.slides.autoplay.start();
        }
      }, 4500);
    }, 4500);
  }

  prev() {
    try {
      this.slider?.swiperRef?.slidePrev(500);
    } catch (e) {
      return e;
    }
  }

  next() {
    try {
      this.slider?.swiperRef?.slideNext(500);
    } catch (e) {
      return e;
    }
  }

  cardOfferDisabled(index: number) {
    // UI-only decision: if processingState is true or promotion explicitly disabled
    if (this.processingStates && this.processingStates[index]) return true;
    const p = this.promotions?.[index];
    return p?.isDisabled || p?.disabled || false;
  }

  onCtaClick(item: any, index: number) {
    if (this.cardOfferDisabled(index)) return;
    this.offerPayment.emit({ item, index });
  }
}
